import { BaseResource } from '@/modules/core/app/resources/BaseResource';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { DashboardFilterOption } from '@/modules/core/dashboard/models/DashboardFilterOption';
import { DashboardFilters } from '@/modules/core/dashboard/models/DashboardFilters';
import { DashboardFilterForm } from '@/modules/core/dashboard/models/DashboardFilterForm';

class DashboardFilterResource extends BaseResource {
  /* eslint-disable tap/no-raw-text-js */
  ROUTE_VIEW = 'view';

  ROUTE_SAVE = 'savefilters';
  /* eslint-enable tap/no-raw-text-js */

  constructor() {
    super(RouteGroup.DASH_DASHBOARDFILTERS);
  }

  /**
   * @returns {Promise<*>}
   * @param dashboardId
   */
  async getFilterOptions(dashboardId = null) {
    return super.getData(DashboardFilterOption, dashboardId);
  }

  /**
   * @returns {Promise<*>}
   */
  async getFilters() {
    return super.getData(DashboardFilters, this.ROUTE_VIEW);
  }

  /**
   * @param model
   * @returns {Promise<*>}
   */
  async saveFilters(model) {
    return super.postData(model, this.ROUTE_SAVE);
  }

  /**
   * @returns {Promise<*>}
   */
  async resetFilters() {
    const form = new DashboardFilterForm({ data: {} });
    return super.postData(form.getResetModel(), this.ROUTE_SAVE);
  }
}
export default new DashboardFilterResource();
